import util from '@/util'
import constants from '@/util/constants'

export const obterValorTotalCarrinho = ({ itens }) => {
  if (util.valorVazio(itens)) return 0

  const valorTotal = itens.reduce((total, item) => {
    const produto = item.produto
    const subtotal = produto.quantidade * produto.plano.valor
    return total + subtotal
  }, 0)
  return valorTotal
}

export const obterTotalItensCarrinho = ({ itens }) => {
  return itens.length
}

export const itensCarrinho = ({ itens }) => {
  return itens
}

export const possuiItensCarrinho = ({ itens }) => {
  return itens.length > 0
}

export const temProdutoMirtContratado = ({ itens }) => itens.some(item => item.produto.id === constants.idProdutoMirt)
